import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';
import {ShareddataService} from '../shared/services/shareddata.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  isloggedin$: BehaviorSubject<boolean>;

  constructor(
    private router: Router,
    private shareddata: ShareddataService,
    private http: HttpClient
  ) {
    this.isloggedin$ = new BehaviorSubject<boolean>(false);
  }

  getExpiration() {
    const expirationData = localStorage.getItem('portal2020_expiration');
    const expiresAt = JSON.parse(expirationData);
    return moment(expiresAt);
  } // getExpiration

  getToken() {
    if (localStorage.getItem('portal2020_token')) {
      // return localStorage.getItem('portal2020_token');
      return localStorage.getItem('portal2020_token');
    } // if
    return '';
  } // getToken


  setLoggedin(flag: boolean) {
    this.isloggedin$.next(flag);
  }

  public checkLocalSession() {
    if (!localStorage.getItem('portal2020_expiration')) {
      this.setLoggedin(false);
    } // if
    if (moment().isBefore(this.getExpiration())) {
      this.setLoggedin(true);
    } else {
      this.setLoggedin(false);
    } // if
  } // isLoggedIn


  public logout() {

    // Launch logout on different tools
    // aos


    // for (let tool of this.shareddata.getUserTools()) {
    //   if (tool.toolclassname === "aos") {
    //     const logoutAosUrl = tool.toolpath + '/services/wp.ax?key=Authentication&a=logout';
    //   } // if
    // } // for

    // Reset some session data
    this.shareddata.changeiframeURL('');
    this.shareddata.setToolOrderListData([]);

    localStorage.removeItem('portal2020_token');
    localStorage.removeItem('portal2020_expiration');
    this.setLoggedin(false);
    this.router.navigate(['']);
  }

}
